import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Accordion } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { initialPath } from "~misc/paths";
import useSimulation from "../../hooks/useSimulation";
import CardGrupoProduto from "./CardGrupoProduto";
import ModalResponse from "~components/Modal/ModalResponse";

const PainelSimulacao = ({ simulacao, cliente, simulador, setIsOpenModalResponse, setLoading, setEnabled, enabled, finishedSimulacoes, refetching, loadingSync, newEnabled, beneficioEnable = false }) => {
  const [isOpenModalSendResponse, setIsOpenModalSendResponse] = useState(false);
  const [linkResponse, setLinkResponse] = useState(null);
  const [save, setSave] = useState(false);

  const onSuccess = (data) => {
    setSave(true);
    setLinkResponse(`${initialPath}/simuladores/${data.clienteId}/simulacao/${data.id}`);

    if (!enabled) setEnabled(true);
    else refetching();
  };

  const onError = () => {
    setLoading(false);
  };

  const { handleSubmit, hierarquiasAprovacaoMaxima } = useSimulation({ simulacao, onSuccess, onError });

  const Submit = (e) => {
    setLoading(true);
    e.preventDefault();
    handleSubmit()
  }

  useEffect(() => {
    if (finishedSimulacoes) {
      setLoading(false);
      setEnabled(false);
      if (save) {
        setIsOpenModalSendResponse(true);
      }
    }
  }, [finishedSimulacoes, loadingSync, newEnabled]);

  return (
    <>
      <Accordion defaultIndex={simulacao?.gruposProduto?.map((item, index) => index)} allowMultiple>
        <form id="simulacao" onSubmit={Submit}>
          {simulacao?.gruposProduto?.length > 0 &&
            simulacao?.gruposProduto?.map((groupProduct, index) => (
              <CardGrupoProduto
              cliente={cliente}
              hierarquiasAprovacaoMaxima={hierarquiasAprovacaoMaxima}
                groupProduct={groupProduct}
                simulador={simulador}
                key={index}
                indexGP={index}
              />
            ))}
        </form>
      </Accordion>

      <ModalResponse
        isOpen={isOpenModalSendResponse}
        status={"success"}
        message={"Salvo com sucesso!"}
        closeModal={() => setIsOpenModalSendResponse(false)}
        link={linkResponse}
      />
    </>
  );
};

export default PainelSimulacao;
